export default "__VITE_ASSET__f7d6b5b0__"